import React from 'react'
import { cn } from 'cn'

export type Props = {
  children: React.ReactNode
  newDesign?: boolean
  className?: string
}

export default function FieldDescription({
  children,
  newDesign,
  className
}: Props) {
  if (!children) return null

  return (
    <p
      className={cn(
        'font-light my-1',
        {
          'italic text-gray-500 text-sm': !newDesign,
          'text-gray-700 text-base': newDesign
        },
        className
      )}
    >
      {children}
    </p>
  )
}
